<template>
  <div></div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TransactionLaunchedListener',
  components: {},
  props: {},
  data() {
    return {
      transactionId: '',
      eventsIds: [],
      checkingInterval: 0,
    }
  },
  mounted() {
    const id2 = this.$Events.handleEvent(
      'transaction_launched',
      this.onTransactionLaunched,
    )
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    clearInterval(this.checkingInterval)
  },
  methods: {
    onTransactionLaunched(response) {
      console.log(response)
      this.transactionId = response?.data?.id
      this.transactionData = {}
      this.periodiCheckTransaction()
    },
    periodiCheckTransaction() {
      clearInterval(this.checkingInterval)
      this.checkingInterval = setInterval(this.checkTransactionStatus, 2000)
    },
    async checkTransactionStatus() {
      console.log('will get status')
      const transactionData = await this.$Events.sendDataRequestResolve(
        'transaction',
        { reference: this.transactionId },
      )
      console.log(transactionData)
      if (!transactionData?.metaData?.srcStatus) return
      if (
        transactionData.metaData.srcStatus !== 'success' &&
        transactionData.metaData.srcStatus !== 'error'
      )
        return
      this.$emit('transactionPaymentDone', {
        status: transactionData.metaData.srcStatus,
      })
      clearInterval(this.checkingInterval)
    },
  },
})
</script>
